
import { returnCheckList, stringContact } from './utilities-function';

export const COOKIE_CHECK_LIST = [
    {
        id: 1,
        check_list: [
        ]
    },
    {
        id: 2,
        group_check_list: [
            {
                name: 'คุกกี้ที่จำเป็น (Strictly Necessary Cookies)',
                description: `คุกกี้ประเภทนี้มีความจำเป็นต่อการทำงานของเว็บไซต์ และไม่สามารถปิดการใช้งานผ่านระบบจัดการคุกกี้ของเว็บไซต์ได้
                            <br/>ตัวอย่างการใช้งาน ได้แก่`,
                footer: `หากปิดใช้งานคุกกี้ประเภทนี้ เว็บไซต์บางส่วนอาจไม่สามารถทำงานได้อย่างถูกต้อง`,
                index_start: 0,
                index_end: 5
            },
            {
                name: 'คุกกี้เพื่อการทำงาน (Functional Cookies)',
                description: `ใช้เพื่อจดจำการตั้งค่าของผู้ใช้งาน เพื่อให้สามารถใช้งานเว็บไซต์ได้สะดวกและเหมาะสมมากขึ้น เช่น`,
                footer: ``,
                index_start: 6,
                index_end: 9
            },
            {
                name: 'คุกกี้เพื่อวิเคราะห์การใช้งาน (Analytics Cookies)',
                description: `ใช้เพื่อเก็บข้อมูลเกี่ยวกับวิธีที่ผู้ใช้งานเข้าชมและใช้งานเว็บไซต์ เช่น`,
                footer: `
                    ข้อมูลดังกล่าวช่วยให้เราสามารถปรับปรุงเว็บไซต์และประสบการณ์การเรียนรู้ให้เหมาะสมยิ่งขึ้น
                    <br/>ข้อมูลที่ใช้ในการวิเคราะห์อาจถูกประมวลผลโดยผู้ให้บริการวิเคราะห์ข้อมูลภายนอก เช่น [Google Analytics / ผู้ให้บริการอื่น] ตามการตั้งค่าที่เรากำหนด
                `,
                index_start: 10,
                index_end: 14
            },
            {
                name: 'คุกกี้เพื่อการตลาด (Marketing Cookies)',
                description: `
                    เราอาจใช้คุกกี้ประเภทนี้เพื่อช่วยให้สามารถนำเสนอข้อมูล ข่าวสาร หรือโฆษณาที่เกี่ยวข้องกับความสนใจของผู้ใช้งานมากขึ้น
                    <br/>คุกกี้ประเภทนี้อาจถูกติดตั้งโดยผู้ให้บริการภายนอกที่เราใช้งาน
                `,
                footer: `ผู้ใช้งานสามารถเลือกปฏิเสธหรือจัดการคุกกี้ประเภทนี้ผ่าน <span class="fw-bold">Cookie Settings</span> ของเว็บไซต์ได้`,
                index_start: -1,
                index_end: -1
            },
        ],
        check_list: [
            `<span>จดจำสถานะการเข้าสู่ระบบ</span>`,
            `<span>รักษาความปลอดภัยของบัญชีผู้ใช้งาน</span>`,
            `<span>จัดการ Session</span>`,
            `<span>ป้องกันการใช้งานที่ผิดปกติ</span>`,
            `<span>จดจำข้อมูลที่จำเป็นต่อการทำงานของระบบ</span>`,
            `<span>จัดการกระบวนการสั่งซื้อและชำระเงิน</span>`,

            `<span>ภาษา</span>`,
            `<span>การตั้งค่าการแสดงผล</span>`,
            `<span>การตั้งค่าบางส่วนของบัญชี</span>`,
            `<span>การตั้งค่าที่ผู้ใช้งานเลือกไว้ก่อนหน้านี้</span>`,

            `<span>หน้าที่เข้าชม</span>`,
            `<span>ระยะเวลาที่ใช้งาน</span>`,
            `<span>จำนวนครั้งในการเข้าชม</span>`,
            `<span>รูปแบบการใช้งาน</span>`,
            `<span>ข้อมูลเกี่ยวกับประสิทธิภาพของเว็บไซต์</span>`,
        ]
    },
    {
        id: 3,
        check_list: [
            `<span>ระบบวิเคราะห์เว็บไซต์</span>`,
            `<span>ระบบชำระเงิน</span>`,
            `<span>ระบบวิดีโอ</span>`,
            `<span>ระบบแชตหรือบริการลูกค้า</span>`,
            `<span>ระบบการตลาด</span>`,
            `<span>ระบบรักษาความปลอดภัย</span>`,
        ]
    },
    {
        id: 4,
        check_list: []
    },
    {
        id: 5,
        check_list: [
            `<span><span class="fw-bold">Session Cookies</span> — ถูกลบเมื่อปิดเว็บเบราว์เซอร์</span>`,
            `<span><span class="fw-bold">Persistent Cookies</span> — ยังคงอยู่บนอุปกรณ์จนกว่าจะครบระยะเวลาที่กำหนดหรือผู้ใช้งานลบออก</span>`,
        ]
    },
    {
        id: 6,
        check_list: []

    },
    {
        id: 7,
        check_list: []
    },
]

export const COOKIE = [
    {
        id: 1,
        name: 'คุกกี้คืออะไร',
        content: `
        คุกกี้ (Cookies) คือไฟล์ข้อมูลขนาดเล็กที่ถูกจัดเก็บไว้บนอุปกรณ์ของผู้ใช้งาน เช่น คอมพิวเตอร์ โทรศัพท์มือถือ หรือแท็บเล็ต เมื่อผู้ใช้งานเข้าชมเว็บไซต์
        <br/>คุกกี้ช่วยให้เว็บไซต์สามารถจดจำข้อมูลบางอย่างเกี่ยวกับผู้ใช้งาน เช่น สถานะการเข้าสู่ระบบ การตั้งค่าภาษา หรือข้อมูลเกี่ยวกับการใช้งานเว็บไซต์
        `
    },
    {
        id: 2,
        name: 'ประเภทของคุกกี้ที่เราใช้',
        content: `
        <p class="mb-0">เราอาจใช้คุกกี้ประเภทต่าง ๆ ดังต่อไปนี้</p>
        ${returnGroupList(2)}
        `
    },
    {
        id: 3,
        name: 'คุกกี้ของบุคคลที่สาม',
        content: `  
          <p class="mb-0">เว็บไซต์อาจมีการใช้งานบริการของบุคคลที่สาม ซึ่งอาจมีการใช้คุกกี้หรือเทคโนโลยีที่คล้ายคลึงกัน เช่น</p>
        ${returnCheckList({ file_data: COOKIE_CHECK_LIST, check_list_id: 3 })}
          <p class="mb-0">การใช้ข้อมูลโดยบุคคลที่สามจะอยู่ภายใต้นโยบายความเป็นส่วนตัวของผู้ให้บริการดังกล่าวด้วย</p>

        `
    },
    {
        id: 4,
        name: 'การจัดการคุกกี้',
        content: `
        ผู้ใช้งานสามารถจัดการหรือปิดการใช้งานคุกกี้ผ่าน<br/>
        <span class="fw-bold">Cookie Settings</span> บนเว็บไซต์<br/>
        นอกจากนี้ ผู้ใช้งานยังสามารถตั้งค่าการใช้คุกกี้ผ่านเว็บเบราว์เซอร์ของตนเองได้<br/>
        อย่างไรก็ตาม หากปิดคุกกี้ที่จำเป็น เว็บไซต์บางส่วนอาจไม่สามารถทำงานได้ตามปกติ
        `
    },
    {
        id: 5,
        name: 'ระยะเวลาการจัดเก็บคุกกี้',
        content: `
        <p class="mb-0">คุกกี้แต่ละประเภทอาจมีระยะเวลาการจัดเก็บแตกต่างกัน โดยแบ่งเป็น</p>
        ${returnCheckList({ file_data: COOKIE_CHECK_LIST, check_list_id: 5 })}
        <p class="mb-0">ระยะเวลาการจัดเก็บคุกกี้อาจแตกต่างกันตามวัตถุประสงค์และผู้ให้บริการของคุกกี้นั้น ๆ</p>

        `
    },
    {
        id: 6,
        name: 'การเปลี่ยนแปลงนโยบาย',
        content: `
        เราอาจปรับปรุงนโยบายการใช้คุกกี้เป็นครั้งคราว เพื่อให้สอดคล้องกับการเปลี่ยนแปลงของบริการ เทคโนโลยี หรือกฎหมายที่เกี่ยวข้อง
        การเปลี่ยนแปลงจะมีผลตั้งแต่วันที่ระบุไว้ในนโยบายฉบับปรับปรุง
        `
    },
    {
        id: 7,
        name: 'ติดต่อเรา',
        content: `หากมีข้อสงสัยเกี่ยวกับการใช้คุกกี้ สามารถติดต่อเราได้ที่
        ${stringContact()}`
    },

]


export function returnGroupList(check_list_id: number, bullet: 'dot' | 'number' = 'dot'): string {
    const group_check_list = COOKIE_CHECK_LIST?.find(item => item.id === check_list_id)!.group_check_list || []
    let innerHtml = group_check_list ? `${group_check_list.map((item, index) => `
        <p class="mb-0 mt-2 fw-bold text-gray-800">${check_list_id}.${index + 1} ${item.name}</p>
        <p class="mb-0 ">${item.description}</p>
        ${returnCheckList({ file_data: COOKIE_CHECK_LIST, check_list_id: check_list_id, index_start: item.index_start, index_end: item.index_end })}
        <p class="mb-0 ">${item.footer}</p>`).join('')} ` : ''
    return innerHtml
}


